import type { OrganizationKind } from "@/shared/organizations/organization-link";
import type { OrganizationMemberRole, OrganizationMemberStatus } from "./types";

export const ORGANIZATIONS_QUERY_KEY = ["admin", "organizations"] as const;

/** The API default (its max is 100). */
export const ORGANIZATIONS_PAGE_SIZE = 20;
export const MEMBERS_PAGE_SIZE = 20;

/** The API rejects a longer `search` with a 400. */
export const ORGANIZATIONS_SEARCH_MAX_LENGTH = 100;
export const ORGANIZATIONS_SEARCH_DEBOUNCE_MS = 300;

/** Locations shown inline per member row; a STAFF member can hold up to 20. */
export const MEMBER_LOCATIONS_INLINE = 3;

export const ORGANIZATION_KINDS: readonly OrganizationKind[] = ["VENUE", "PROPERTY"];
export const MEMBER_ROLES: readonly OrganizationMemberRole[] = ["OWNER", "ADMIN", "STAFF"];
export const MEMBER_STATUSES: readonly OrganizationMemberStatus[] = ["ACTIVE", "INACTIVE"];

/** The organization name rules of the API (trimmed length, no uniqueness constraint). */
export const ORGANIZATION_NAME_MIN_LENGTH = 2;
export const ORGANIZATION_NAME_MAX_LENGTH = 30;
